import styled from 'styled-components';

export interface TableRowProps {
  columns: string[];
  header?: boolean;
  onRowClick?: () => void;
  selected?: boolean;
  testId?: string;
  rowId?: string;
}

export const TableRow = ({
  columns,
  header,
  onRowClick,
  selected,
  testId,
  rowId,
}: TableRowProps) => (
  <Container
    onClick={onRowClick}
    header={header}
    selected={selected}
    data-testid={testId}
  >
    {columns.map((column, i) => (
      <Cell key={`${rowId}-${column}-${i}`}>
        <CellText header={header}>{column}</CellText>
      </Cell>
    ))}
  </Container>
);

const Container = styled.div<Partial<TableRowProps>>`
  display: flex;
  padding: 0 16px 0 0;
  ${({ theme, header, selected }) =>
    selected &&
    !header &&
    `
        background-color: ${theme.isVaultVariant ? theme.newPalette.turquoise.T300 : theme.atlas.semantic.color.action.primary.default};
        cursor: pointer;
        ${CellText} {
            color: ${theme.isVaultVariant ? theme.newPalette.neutral.N0 : theme.atlas.semantic.color.type.inverse};
        }
  `}
  ${({ theme, header }) =>
    header
      ? `
        background-color: ${theme.isVaultVariant ? theme.newPalette.neutral.N100 : theme.atlas.semantic.color.surface.subtle};
        border: 1px solid ${theme.isVaultVariant ? theme.newPalette.neutral.N300 : theme.atlas.semantic.color.outline.fixed};
        border-top: none;
  `
      : `
    &:hover {
        background-color: ${theme.isVaultVariant ? theme.newPalette.turquoise.T300 : theme.atlas.semantic.color.action.primary.default};
        cursor: pointer;
        ${CellText} {
            color: ${theme.isVaultVariant ? theme.newPalette.neutral.N0 : theme.atlas.semantic.color.type.inverse};
        }
    }
  `}
`;

const Cell = styled.div`
  display: flex;
  justify-content: flex-start;
  flex: 1;
  padding-left: 16px;
`;

const CellText = styled.p<Partial<TableRowProps>>`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 14px;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 8px 0 8px 0;
  ${({ header }) => !header && 'font-weight: 300;'}
`;
